import { pathSubscription, useReframe } from 'nike-re-framejs';

export type Theme = 'light' | 'dark';

export const booleanToTheme = (value?: Boolean) => {
    switch (value) {
        case true:
            return 'dark';
        case false:
            return 'light';
        default:
            return undefined;
    }
};

export const stringToTheme = (value: String) => {
    switch (value) {
        case 'true':
            return 'dark';
        case 'false':
            return 'light';
        default:
            return undefined;
    }
};

export const setTheme = (theme: Theme, persist: boolean = true) => db => {
    if (theme === 'dark') {
        document.body.classList.add('theme-dark');
    } else if (theme === 'light') {
        document.body.classList.remove('theme-dark');
    }
    if (persist) {
        localStorage.setItem('themeDark', theme === 'dark' ? 'true' : 'false');
    }
    return db.set('theme', theme);
};

export const initTheme = (userSettingsValue?: Theme) => db => {
    if (!window['theming']) {
        return db;
    }
    if (isFixedDarkTheme()) {
        return setTheme('dark', false)(db);
    }
    if (document.location.pathname === '/tmavatema') {
        return setTheme('dark')(db);
    }
    if (document.location.pathname === '/svetlatema') {
        return setTheme('light')(db);
    }
    if (userSettingsValue) {
        return setTheme(userSettingsValue)(db);
    }
    const lsValue = stringToTheme(window.localStorage.getItem('themeDark'));
    if (lsValue) {
        return setTheme(lsValue)(db);
    }
    return setThemeFromOS(db);
};

function setThemeFromOS(db) {
    const darkModeMatcher = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
    const prefersColorSupported = !!darkModeMatcher && darkModeMatcher.media !== 'not all';
    return setTheme(prefersColorSupported && darkModeMatcher.matches ? 'dark' : 'light')(db);
}

export const theme$ = pathSubscription(['theme']);

export const useDarkTheme = () => {
    const { subscribe } = useReframe();
    return subscribe(theme$) === 'dark';
};

export function isFixedDarkTheme() {
    return window.location.pathname.startsWith('/casino');
}
